import React from "react";

import { LineInput } from "components/Inputs/LineInput";
import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

export default class ContinuousTime extends React.PureComponent {
  render() {
    const {
      id,
      isShow,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      timePeriod,
      threshold,
      options,
      outcome,
      updateThreshold,
      updateTimePeriod,
      updateConversionGain,
      updateConversionCost,
      unitType,
      updateUnitType
    } = this.props;

    const isLocked = options && options["lock"];

    return (
      <div className={styles.body}>
        <AibleStep
          id={id}
          bId={"contTimePeriod"}
          message={"What is the unit of measure (USD, Hours, etc.)"}
          isBreak={true}
          optionsHolder={false}
        />
        <div className={styles.contOuterDropHolder}>
          <div className={styles.dropHolder}>
            <LineInput
              defaultValue={unitType}
              isMediumBox
              isLocked={isLocked}
              onChange={(val) => updateUnitType(val)}
            />
          </div>
        </div>
      </div>
    );
  }
}
